module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAMCAYAAAC9QufkAAAAAXNSR0IArs4c6QAAAP9JREFUKBWN0UGLQVEYxnHKioYsRsraF5CysKNJdqOsaDY2ms0kOxtLFpaUBbY28g3G1kbTfACaGrIhCzMLKeH/TG4Z3Yunfveec99zTve+12azTphSF3P8YogqHnA1Bao7fKKEPBpY4hsR/EuUmRcxHNCGA+d5ZDLAFB6j8MJgjwwCyMIqOmCBmp1LCj184BU6xCwrHs5OhSb3kMZr6DVv2bDG+Iw3xj+aFNHCCGXoELOoWWqiEsT4b8RF3dWmNNS0OKzipqDXr58veGbiRxI6qILLuHjQhxrmuywac23UAe/IQU3VJ31BjXvC1SSoavMW+gMTdKC3uzv6nU6z1UeZVDtSMgqWIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logout.png
// module id = 311
// module chunks = 0